export default "__VITE_ASSET__df485003__"